import React from 'react';

import styled, { css } from 'styled-components';

const Text = styled.div(
  ({ theme }) => css`
    cursor: default;
    ${theme.textTypes['Subtitle-1-w500']}
    color: ${theme.colors.gray700};
    font-size: 12px;
    width: 100%;
    text-align: center;
    margin-top: -24px;
  `
);

const NoMoreMovements = ({children}) => <Text>{children}</Text>;

export default NoMoreMovements;
